import * as React from 'react';
import type { ServiceOrderListEntry } from 'contracts/service-orders';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { Separator } from 'components/ui/separator';
import { cn } from 'lib/utils';

type Props = {
  tasks: ServiceOrderListEntry['tasks']
}

export const TasksListPopover = ({ tasks }: Props) => {
  return (
    <Popover>
      <PopoverTrigger onClick={(event) => {
        event.stopPropagation();
      }}>
        <span
          className={cn(
            'flex items-center justify-center',
            'bg-gray-100 border border-gray-300 rounded-sm',
            'text-xs text-gray-600 font-sans font-medium',
            'px-2 h-6')}
        >
          {tasks.length}
        </span>
      </PopoverTrigger>
      <PopoverContent align={'center'} className={'text-gray-600'}>
        {tasks.map((task, index) => (
          <div className={'flex flex-col'} key={task.id}>
            <div className={'py-2'} key={task.id}>{task.task}</div>
            {index < tasks.length - 1 && <Separator />}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};